import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CircularProgress } from '@mui/material';
import { closeSnackbar, CustomContentProps, SnackbarContent } from 'notistack';
import { forwardRef } from 'react';

import { StyledAlert } from './CustomSnackbar.styled';

export const CustomSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => {
    const onClose = () => {
      closeSnackbar(props.id);
    };

    const getVariant = (
      variant: 'success' | 'error' | 'info' | 'warning' | 'default',
    ) => {
      switch (variant) {
        case 'success': {
          return 'success';
        }
        case 'info': {
          return 'info';
        }
        case 'warning': {
          return 'warning';
        }
        case 'error':
        case 'default':
        default: {
          return 'error';
        }
      }
    };

    return (
      <SnackbarContent ref={ref}>
        <StyledAlert
          onClose={onClose}
          icon={
            props.variant === 'success' ? (
              <CheckCircleOutlineIcon />
            ) : props.variant === 'info' ? (
              <CircularProgress size={20} />
            ) : null
          }
          severity={getVariant(props.variant)}>
          {props.message}
        </StyledAlert>
      </SnackbarContent>
    );
  },
);
